import LocalizationService from "./configLangContext";

export class i19n {

   static t(key, placeholders = {}) {
      const langContext = LocalizationService.getInstance();
      var translateObj = langContext.currentTranslateObject
      if(translateObj.hasOwnProperty(key)) {
         let translation = translateObj[key];
         translation = translation.replace(/{{(.*?)}}/g, (match, p1) => {
            const trimmedKey = p1.trim();
            return placeholders.hasOwnProperty(trimmedKey) ? placeholders[trimmedKey] : match;
         });

         return translation;
      }
      return ""
   }
}


